import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Truncate from 'react-truncate';
import LazyImg from '../LazyImg';
import ImageLoader from '../ImageLoader';

interface PodcastType {
  podcastId: string;
  imgUrl: string;
  category: string;
  categoryId: string;
  name: string;
}

interface PodcastProps {
  podcast: PodcastType;
  onClick: () => void;
}

const Podcast: React.FC<PodcastProps> = ({ podcast, onClick }) => {
  const { podcastId, imgUrl, name } = podcast;
  return (
    <div
      className="img-slider"
      key={podcastId}
      style={{ width: '120px' }}
      data-toggle="tooltip"
      data-placement="top"
    >
      {/* <LazyImg src={imgUrl} onClick={onClick} /> */}
      <ImageLoader
        id={podcastId}
        src={imgUrl}
        width="120px"
        height="120px"
        onClick={onClick}
      />
      <div className="podcast-name">
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="top"
          overlay={<Popover id="popover-basic">{name}</Popover>}
        >
          <Truncate lines={2} ellipsis={'...'} width={120}>
            {name}
          </Truncate>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default Podcast;
